export default __webpack_public_path__ + "static/media/10.c2e0408a.jpg";